import React, { useEffect } from "react";
// import { MuiBox } from "components/atoms";
import { useDispatch, useSelector } from "react-redux";
import { Modal } from "@mui/material";
import { MuiBox } from "components/atoms";
import { closeFullScreenModal } from "store/slices/common/fullScreenMedia.slice";

const FullScreenModal = () => {
  const dispatch = useDispatch();

  const { isModalOpen, selectedMedia, type } = useSelector(
    (state) => state.fullScreenMedia,
  );

  const handleClose = () => {
    dispatch(closeFullScreenModal());
  };

  useEffect(() => {
    const handleEsc = (event) => {
      if (event.key === "Escape") {
        handleClose();
      }
    };

    if (isModalOpen) {
      window.addEventListener("keydown", handleEsc);
    }

    return () => {
      window.removeEventListener("keydown", handleEsc);
    };
  }, [isModalOpen]);

  return (
    <Modal
      sx={{
        color: "#fff",
        zIndex: 99999999,
        bgcolor: "#000000BF",
      }}
      open={isModalOpen}
      onClick={handleClose}
    >
      <MuiBox
        sx={{
          position: "fixed",
          inset: "0px",
          display: "flex",
          padding: "20px",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        {type === "image" && (
          <MuiBox
            sx={{
              height: "calc(100dvh - 200px)",
              maxWidth: "calc(100dvw - 200px)",
            }}
          >
            <img
              src={selectedMedia}
              alt=""
              className="pointer-events-none img-contain"
            />
          </MuiBox>
        )}
        {type === "video" && (
          <MuiBox
            sx={{
              maxWidth: "400px",
            }}
          >
            <video
              src={selectedMedia}
              controls
              autoPlay
              className="h-full w-full pointer-events-auto"
              style={{ height: "100%" }}
            />
          </MuiBox>
        )}
      </MuiBox>
    </Modal>
  );
};

export default FullScreenModal;
